import vue from "vue";

vue.filter('rounded', (value) => {
    if (!value) return '0';
    return Math.round(parseFloat(value.replace(',', '.')));
});



// WEBPACK FOOTER //
// ./src/filters/rounded.filter.js